/*!
=========================================================
* Painel Toca da Onça — Cérebro Único
=========================================================
* Junta TODAS as fontes num lugar só. É o mapa que os agentes (Carmen, Jarvis) leem.
*/
import React from "react";
import { Card, CardBody, CardTitle, Row, Col, Button, Badge } from "reactstrap";

const brl = (v) => "R$ " + Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
const num = (v) => Number(v || 0).toLocaleString("pt-BR");

function Fonte({ icon, cor, titulo, sub, linhas, to }) {
  return (
    <Col lg="6">
      <Card style={{ minHeight: 210 }}>
        <CardBody>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: cor, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <i className={"tim-icons " + icon} style={{ fontSize: 22, color: "#fff" }} />
            </div>
            <div>
              <CardTitle tag="h4" className="text-white" style={{ margin: 0 }}>{titulo}</CardTitle>
              <p className="text-muted" style={{ margin: 0, fontSize: 12 }}>{sub}</p>
            </div>
          </div>
          <Row>
            {linhas.map((l, i) => (
              <Col xs="6" key={i} style={{ marginBottom: 10 }}>
                <p className="text-muted" style={{ margin: 0, fontSize: 12 }}>{l.k}</p>
                <p className="text-white" style={{ margin: 0, fontSize: 20, fontWeight: 600, color: l.cor }}>{l.v}</p>
              </Col>
            ))}
          </Row>
          {to && <Button color="info" size="sm" href={to} tag="a">Abrir</Button>}
        </CardBody>
      </Card>
    </Col>
  );
}

function Cerebro() {
  const [site, setSite] = React.useState(null);
  const [crm, setCrm] = React.useState(null);
  const [forn, setForn] = React.useState(null);

  React.useEffect(() => {
    fetch("http://localhost:8787/cerebro").then((r) => r.ok ? r.json() : null).then(setSite).catch(() => {});
    fetch("/stats.json", { cache: "no-store" }).then((r) => r.ok ? r.json() : null).then(setCrm).catch(() => {});
    fetch("/fornecedores.json", { cache: "no-store" }).then((r) => r.ok ? r.json() : null).then(setForn).catch(() => {});
  }, []);

  const fornTotal = forn && forn.totalBase ? num(forn.totalBase) : "~1,7 mi";

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>
            <i className="tim-icons icon-atom text-info" /> Cérebro único
          </h3>
          <p className="text-muted">
            Tudo que o negócio sabe, num lugar só — puxado de cada fonte ao vivo. É o mapa que a Carmen e o Jarvis leem.
          </p>
        </Col>
      </Row>

      <Row>
        <Fonte
          icon="icon-bag-16" cor="#1d8cf8" titulo="Site (tocadaoncamodas.com.br)" sub="Supabase — loja no ar"
          to="/admin/dashboard"
          linhas={[
            { k: "Produtos ativos", v: site ? num(site.produtos) : "…", cor: "#1d8cf8" },
            { k: "Valor em estoque", v: site ? brl(site.estoque) : "…", cor: "#00f2c3" },
            { k: "Pedidos online", v: site ? num(site.pedidos) : "…" },
            { k: "Compradores", v: site ? num(site.compradores) : "…" },
          ]}
        />
        <Fonte
          icon="icon-single-02" cor="#e14eca" titulo="Clientes (CRM)" sub="WhatsApp + grupos"
          to="/admin/regioes"
          linhas={[
            { k: "Clientes na base", v: crm ? num(crm.totalClientes) : "…", cor: "#e14eca" },
            { k: "Revendedoras", v: crm ? num(crm.revendedoras) : "…", cor: "#00f2c3" },
            { k: "Leads quentes", v: crm ? num(crm.quente) : "…", cor: "#fd5d93" },
            { k: "Estados", v: crm && crm.regioes ? crm.regioes.length : "…" },
          ]}
        />
        <Fonte
          icon="icon-square-pin" cor="#ff8d72" titulo="Fornecedores (CNPJ Brasil)" sub="Base no HD — E:\\JARVIS_DADOS"
          to="/admin/fornecedores"
          linhas={[
            { k: "Empresas de roupa", v: fornTotal, cor: "#ff8d72" },
            { k: "Fonte", v: "Receita" },
            { k: "Consulta", v: "por CNAE + UF" },
            { k: "Acesso", v: "Jarvis" },
          ]}
        />
        <Fonte
          icon="icon-money-coins" cor="#00bf9a" titulo="PDV (balcão)" sub="vendas → banco do site"
          to="/admin/notifications"
          linhas={[
            { k: "Vendas hoje", v: site ? num(site.vendasPdv) : "…", cor: "#00bf9a" },
            { k: "Caixa hoje", v: site ? brl(site.caixaHoje) : "…", cor: "#00f2c3" },
            { k: "Grava em", v: "banco do site" },
            { k: "Segurança", v: "bridge" },
          ]}
        />
      </Row>

      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="text-white"><i className="tim-icons icon-atom text-info" /> Agentes ligados neste cérebro</CardTitle>
              <div style={{ marginTop: 8 }}>
                <Badge color="success" pill style={{ marginRight: 8 }}>● Carmen — WhatsApp</Badge>
                <Badge color="info" pill style={{ marginRight: 8 }}>Jarvis — CNPJ / fornecedores</Badge>
                <Badge color="warning" pill style={{ marginRight: 8 }}>○ RH · Fiscal · Nemotron (prontos)</Badge>
              </div>
              <p className="text-muted" style={{ marginTop: 12, fontSize: 13 }}>
                Cada agente lê as skills (marketplaces, CNPJ, felicitações) e estas fontes. Quando um dado muda numa fonte, é aqui que todos veem.
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Cerebro;
